/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EntityStatusEnum } from './entityStatusEnum';


export interface CreateApiCredentialsDto { 
    username?: string;
    apikey?: string;
    token?: string;
    expiration?: Date;
    grantType?: string;
    principal?: string;
    password?: string;
    email?: string;
    dateCreated?: Date;
    entityStatusEnum: EntityStatusEnum;
    creatorId?: string;
    description?: string;
    smsRouteName?: string;
    systemId?: string;
}
